import { render, staticRenderFns } from "./GroupHeaderImageModal.vue?vue&type=template&id=88f87ed0"
import script from "./GroupHeaderImageModal.vue?vue&type=script&lang=js"
export * from "./GroupHeaderImageModal.vue?vue&type=script&lang=js"
import style0 from "./GroupHeaderImageModal.vue?vue&type=style&index=0&id=88f87ed0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports